import { gql } from 'graphql-request'

export namespace LeadMutations {
  export function createLead() {
    return gql`
      mutation createLead($lead: LeadInsertMutation) {
        createLead(lead: $lead) {
          id
          firstName
          lastName
          email
          phone
        }
      }
    `
  }

  export function updateLead() {
    return gql`
      mutation updateLead($lead: LeadUpdateMutation) {
        updateLead(lead: $lead) {
          id
        }
      }
    `
  }
}
